import type { ButtonHTMLAttributes } from 'react';
import styles from './Button.module.css';

type Variant = 'primary' | 'secondary' | 'danger';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
}

const variantClass: Record<Variant, string | undefined> = {
  primary: undefined,
  secondary: styles.secondary,
  danger: styles.danger,
};

/** Small styled button with primary/secondary/danger variants. */
export function Button({ variant = 'primary', className, ...props }: ButtonProps) {
  const classes = [styles.button, variantClass[variant], className].filter(Boolean).join(' ');
  return <button className={classes} {...props} />;
}
